/* ═══════════════════════════════════════════════════
   Cart drawer

   ⚠ FOCUS BIJ SLUITEN — NIET TERUGDRAAIEN

   Hier stond:
     open()  : this.previousElement = document.activeElement || toggle
     close() : this.previousElement.focus()

   Bedoeling was netjes: focus teruggeven aan waar je vandaan kwam.
   In de praktijk gaf dat een bug. Als het element met focus vóór het
   openen het zoekveld was, kreeg dat veld bij sluiten opnieuw focus, en
   het zoekpaneel ("Popular right now") opent op focus. Je klikte dus op
   het kruisje en er ging meteen een ander paneel open. Voor de bezoeker
   leest dat als "het sluit niet".

   Nu gaat de focus altijd naar de winkelwagenknop. Dat is waar
   toegankelijkheidsrichtlijnen hem willen hebben — terug naar het
   element dat het paneel opende — en die knop opent niets vanzelf.

   Tweede fix: open() deed querySelector('a[href]').focus() zonder
   controle. In een lege winkelwagen is er geen enkele link en gooide dat
   een TypeError, waardoor alles ná die regel in de klasse stil stopte.
   ════════════════════════════════════════════════════ */

class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.cartDrawerToggle = document.querySelector('.section-header-cart-drawer-toggle');
        this.cartDrawer = this;
        this.cartDrawerClose = this.querySelector('.cart-drawer-close');
        this.cartDrawerOverlay = this.querySelector('.cart-drawer-overlay');
        this.cartDrawerEmptyRedirect = this.querySelector('.cart-drawer-empty-footer');

        this.setAttribute('tabindex', '-1');

        if (this.cartDrawerToggle) {
            this.cartDrawerToggle.addEventListener('click', (event) => this.onClick(event));
        }

        if (this.cartDrawerClose) {
            this.cartDrawerClose.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.close();
            });
            this.cartDrawerClose.addEventListener('keyup', (event) => this.onCloseKeypress(event));
        }

        if (this.cartDrawerOverlay) {
            this.cartDrawerOverlay.addEventListener('click', () => this.close());
        }

        document.addEventListener('keyup', (event) => {
            if (event.key === 'Escape') {
                this.close();
            }
        });

        if (this.cartDrawerEmptyRedirect) {
            this.cartDrawerEmptyRedirect.addEventListener('click', () => this.close());
        }
    }

    onClick(event) {
        event.preventDefault();
        this.open();
    }

    onCloseKeypress(event) {
        if (event.key === 'Enter') {
            this.close();
        }
    }

    open() {
        this.cartDrawer.setAttribute('aria-hidden', 'false');
        this.cartDrawer.classList.add('active');

        /* Focus naar de eerste link in het paneel. In een lege wagen is
           die er niet, dus vallen we terug op het paneel zelf. */
        setTimeout(() => {
            const first = this.querySelector('a[href], button:not([disabled])');
            if (first) {
                first.focus({ preventScroll: true });
            } else {
                this.focus({ preventScroll: true });
            }
        }, 100);
    }

    close() {
        this.cartDrawer.setAttribute('aria-hidden', 'true');
        this.cartDrawer.classList.remove('active');

        /* Altijd terug naar de winkelwagenknop, nooit naar het element dat
           toevallig focus had. Zie de uitleg bovenaan dit bestand. */
        if (this.cartDrawerToggle && typeof this.cartDrawerToggle.focus === 'function') {
            this.cartDrawerToggle.focus({ preventScroll: true });
        }

        const quickviewElement = document.querySelector('.popup-modal-quickview:not(.inactive)');
        if (quickviewElement) {
            const submit = quickviewElement.querySelector('button[type="submit"]');
            if (submit) {
                submit.focus({ preventScroll: true });
            }
        }
    }
}

customElements.define('cart-drawer', CartDrawer);
